import { Card } from "antd";
import React from "react";
import Field from "../../../../components/Field";
import { useTranslation } from "react-i18next";
import WavelengthField from "../MPE_AEL/QuickFields/WavelengthField";

export function DRCWFields({ isFree = false }) {
    const { t } = useTranslation()
    return (<Card title={`CW Settings`}>
        {/* Wavelength */}
    
        <WavelengthField disabled={isFree} name={['diffuseReflectiveCW', 'wavelength']} />

        {
            /* Exposure */
        }
        <Field tabIndex={2} disabled={isFree} isCW name={['diffuseReflectiveCW', 'time']} unit='s' denoms={[false, 'm', 'u', 'n', 'p', 'f']} label={t('10077')/* Exposure Duration*/} placeholder='Enter emission duration' min={0.25} toolTipText='The total time period in seconds for which direct eye exposure to laser radiation is anticipated.' />

        {
            /* Power */
        }
        <Field tabIndex={3} disabled={isFree} name={['diffuseReflectiveCW', 'power']} unit='W' denoms={['G', 'M', 'k', false, 'm', 'u', 'n', 'p']} label={t('10094')/**Laser Output Power*/} toolTipText={'The continuous power output of the laser beam.'} placeholder={`Enter laser's power`} />

        {
            /* Beam Diameter */
        }
        <Field tabIndex={4} disabled={isFree} name={['diffuseReflectiveCW', 'beamDiameter']} label={t('10080')/** Beam Diameter */} unit='mm' placeholder={`Enter laser's beam diameter`} toolTipText={`The diameter of the source of the laser beam.`} />
        {
            /* Beam Divergence */
        }
        <Field tabIndex={5} disabled={isFree} name={['diffuseReflectiveCW', 'beamDivergence']} label={t('10081')/** Beam Divergence */} unit='rad' denoms={['m', false, 'degree']} placeholder={`Enter laser's beam divergence`} toolTipText={`The far field plane angle of the cone defined by the beam diameter.`} />

        <Field  tabIndex={6} disabled={isFree} name={['diffuseReflectiveCW', 'distance']} label={t('10093')/**Laser to Surface Distance */} unit='m' denoms={['k', false, 'm', 'c', 'u', 'n']} placeholder={`Enter distance between laser and reflecting surface`} toolTipText={`The distance between the source of the laser and the reflecting surface.`} />




    </Card>);
}
